module.exports = __webpack_public_path__ + "static/media/qrcode.fc375c89.png";